// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getObject(key: string, defaultObj?: any): any {
    try {
        const item = localStorage.getItem(key);

        if (!item) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return defaultObj;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(item);
    } catch (e) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return defaultObj;
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setObject(key: string, obj: any): void {
    localStorage.setItem(key, JSON.stringify(obj));
}

export default {
    getObject,
    setObject
};
